// Data sevice
import axios from 'axios'
import authHeader from './auth-header'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const API_URL = process.env.VUE_APP_API_URL;

class DraftService {

    index() {
        return axios.get(API_URL + 'drafts', { headers: authHeader() })
    }
    show(id) {
        return axios.get(API_URL + 'drafts/' + id, { headers: authHeader() })
    }
    store(resource) {
        return axios.post(API_URL + 'drafts', resource, { headers: authHeader() })
    }
    update(resource) {
        return axios.put(API_URL + 'drafts/' + resource.id, resource, { headers: authHeader() })
    }
    delete(resource) {
        return axios.delete(API_URL + 'drafts/' + resource.id, { headers: authHeader() })
    }

    userDrafts(id) {
        return axios.get(API_URL + 'user-drafts/' + id, { headers: authHeader() })
    }
}

export default new DraftService()